import meta from './lang/meta.json' with { type: 'json' };
import xxa from './lang/xxa';
import { createTranslator, type FlattenDict } from 'schummar-translate/react';

const dicts = Object.fromEntries(
  Object.entries(import.meta.glob('./lang/*.ts', { import: 'default' })).map(([key, value]) => [
    key.match(/\.\/lang\/(.*)\.ts$/)![1],
    value,
  ]),
);

export type Dict = typeof xxa;
export type FlatDict = FlattenDict<Dict>;
export type AppTranslator = Awaited<ReturnType<typeof getTranslator>>;
export type AppInlineTranslator = typeof t;
export type AppHookTranslator = ReturnType<typeof useTranslator>;

export const { t, useTranslator, getTranslator, TranslationContextProvider } = createTranslator<typeof xxa>({
  sourceLocale: 'xxa',
  sourceDictionary: xxa,
  fallbackLocale: ['en', 'xxa'],
  dateTimeFormatOptions: { dateStyle: 'medium', timeStyle: 'medium' },
  dicts,
});

export const availableLanguages = meta.languages.filter((x) => x.language !== 'xxa');
